import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SongTable from '../components/SongTable';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useAuth } from '../hooks/useAuth';

export default function ArtistPage() {
  const { id } = useParams();
  const { authToken } = useAuth();
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [artistName, setArtistName] = useState('');
  const [queueLoading, setQueueLoading] = useState(false);

  useEffect(() => {
    // Scroll to top when artist changes
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const fetchArtistSongs = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`/api/artist/${id}`);
        setSongs(data.songs || []);
        setArtistName(data.artist || '');
      } catch (err) {
        console.error('❌ Failed to fetch artist songs:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchArtistSongs();
  }, [id]);

  const queueSong = async (options) => {
    setQueueLoading(true);
    try {
      if (!authToken) {
        toast.error('You must be logged in to queue songs');
        setQueueLoading(false);
        return;
      }
      
      const response = await axios.post('/api/queue', 
        {
          artist_id: id,
          ...options
        },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          }
        }
      );
      
      if (response.data.success) {
        toast.success(`✅ Queued: ${response.data.song_details.artist} - ${response.data.song_details.title}`);
      }
    } catch (error) {
      console.error('Failed to queue song:', error);
      toast.error(`❌ ${error.response?.data?.error || 'Failed to queue song'}`);
    } finally {
      setQueueLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">
        🎶 Songs by {artistName || 'this artist'}
      </h1>
      
      {/* Queue buttons */}
      <div className="mb-6 flex flex-wrap gap-2">
        <button 
          onClick={() => queueSong({ least_recent: true })}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded disabled:opacity-50"
          disabled={queueLoading || !authToken}
          title={!authToken ? "Login required" : ""}
        >
          {queueLoading ? 'Queueing...' : 'Least Recent Song'}
        </button>
        <button 
          onClick={() => queueSong({})}
          className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded disabled:opacity-50"
          disabled={queueLoading || !authToken}
          title={!authToken ? "Login required" : ""}
        >
          {queueLoading ? 'Queueing...' : 'Random Song'}
        </button>
        <button 
          onClick={() => queueSong({ min_vote: 3 })}
          className="bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-2 px-4 rounded disabled:opacity-50"
          disabled={queueLoading || !authToken}
          title={!authToken ? "Login required" : ""}
        >
          {queueLoading ? 'Queueing...' : 'Random 3⭐+'}
        </button>
        <button 
          onClick={() => queueSong({ min_vote: 4 })}
          className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded disabled:opacity-50"
          disabled={queueLoading || !authToken}
          title={!authToken ? "Login required" : ""}
        >
          {queueLoading ? 'Queueing...' : 'Random 4⭐+'}
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : songs.length === 0 ? (
        <p>No songs found for this artist.</p>
      ) : (
        <SongTable
  songs={songs.map(s => ({ ...s.song, ...s }))}
  showTime={false}
  showRequest
  disableRequestIf={() => false}
  hideRequester={true}
  sortable={true}
/>

      )}
    </div>
  );
}
